import type { ReactNode } from 'react';
import classes from './SegmentedButtons.module.css';

export interface SegmentedButtonsProps<T extends string> {
  options: { value: T; label: ReactNode }[];
  value: T;
  onChange: (value: T) => void;
  /** Name the group with one of these two. */
  'aria-label'?: string;
  'aria-labelledby'?: string;
  disabled?: boolean;
}

export function SegmentedButtons<T extends string>({
  options,
  value,
  onChange,
  'aria-label': ariaLabel,
  'aria-labelledby': ariaLabelledBy,
  disabled,
}: SegmentedButtonsProps<T>) {
  return (
    <fieldset className={classes.group} aria-label={ariaLabel} aria-labelledby={ariaLabelledBy}>
      {options.map((option) => (
        <button
          key={option.value}
          type="button"
          className={classes.button}
          aria-pressed={option.value === value}
          disabled={disabled}
          onClick={() => {
            if (option.value !== value) onChange(option.value);
          }}
        >
          {option.label}
        </button>
      ))}
    </fieldset>
  );
}
